var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_8","data-name":"Layer 8"},React.createElement("path",{"id":"Path_1266","data-name":"Path 1266","d":"M15.374,13.356l-2.463,2.5a.489.489,0,0,1-.345.145.408.408,0,0,1-.187-.04.5.5,0,0,1-.305-.46v-2H.993a.5.5,0,0,1,0-1H12.074v-2a.5.5,0,0,1,.305-.46.487.487,0,0,1,.537.105l2.463,2.5a.456.456,0,0,1,.108.165.508.508,0,0,1,0,.12.172.172,0,0,1,0,.14.508.508,0,0,1,0,.12A.455.455,0,0,1,15.374,13.356Z","transform":"translate(-0.5 -10.002)"})));
}

ArrowInline.defaultProps = {"id":"noun_Arrow_3257687","width":"15.002","height":"6","viewBox":"0 0 15.002 6"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
